import styles from "../products/analytics-table.module.css"

export default function SupplierSummary({ suppliers }) {
  return (
    <div className={styles.tableContainer}>
      <h2>Supplier Summary</h2>
      <div className={styles.tableWrapper}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>Supplier</th>
              <th>Orders</th>
              <th>Product Count</th>
              <th>Avg Cost</th>
              <th>Total Cost</th>
              <th>Total Revenue</th>
              <th>Total Profit</th>
              <th>Profit Margin</th>
            </tr>
          </thead>
          <tbody>
            {suppliers?.map((supplier, index) => (
              <tr key={index}>
                <td>{supplier._id}</td>
                <td>{supplier.orders}</td>
                <td>{supplier.productCount}</td>
                <td>{supplier.avgCost}</td>
                <td>{supplier.totalCost}</td>
                <td>{supplier.totalRevenue}</td>
                <td>{supplier.totalProfit}</td>
                <td>{supplier.profitMargin}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}
